export default __webpack_public_path__ + "static/top.url-43ecf537c603be4a9d03edae7b2b1c48.svg";